// extracted by mini-css-extract-plugin
export var aircallIframe = "_lr-3";
export var fabContainer = "_lr-5";
export var fabRinging = "_lr-6";
export var loadingOverlay = "_lr-4";
export var pulse = "_lr-7";
export var widgetContent = "_lr-2";
export var widgetPanel = "_lr-0";
export var widgetPanelExpanded = "_lr-1";